import Signup from 'components/Signup'

export default Signup
